import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=460935d0&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('460935d0')) {
      api.createRecord('460935d0', component.options)
    } else {
      api.reload('460935d0', component.options)
    }
    module.hot.accept("./Orders.vue?vue&type=template&id=460935d0&", function () {
      api.rerender('460935d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/views/Orders.vue"
export default component.exports